import { Language, LocalizedString } from 'hic-components'
import { useCallback } from 'react'
import useCurrentLocale from './use-current-locale'

export default function useLocalizeString() {
  const { hicLanguage } = useCurrentLocale()
  const localizeString = useCallback(
    (localizedString: LocalizedString | null | undefined, language?: Language): string => {
      if (!localizedString) return ''
      const locale =
        localizedString.find((ls) => language && ls.language === language && ls.value) ||
        localizedString.find((ls) => hicLanguage && ls.language === hicLanguage && ls.value) ||
        localizedString.find((ls) => ls.language === 'it' && ls.value) ||
        localizedString.find((ls) => ls.language === 'en' && ls.value) ||
        localizedString.find((ls) => ls.value)

      return locale?.value || ''
    },
    [hicLanguage],
  )
  return localizeString
}
